// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3Y_a3","obliqueLineWrap":"membershipbadge_obliqueLineWrap__IRUa-","obliqueLine":"membershipbadge_obliqueLine__Gcou9"};